<span class="bany-badge" [ngClass]="'badge-' + type">
  {{ number }}
</span>
